import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { DocsRequests } from 'src/requests/docs';
import { QueryKey } from 'src/utils/react-query';

export const useDocQuery = (docId?: string | undefined) => {
  const { id = '' } = useParams();

  const queryDocId = docId || id;

  const _queryClient = useQueryClient();

  const {
    data: doc,
    isLoading: isDocLoading,
    refetch,
  } = useQuery({
    queryKey: [QueryKey.DOC, queryDocId],
    enabled: !!queryDocId,
    queryFn: () => DocsRequests.getDocById(queryDocId),
    // onSuccess(updatedDoc) {
    //   queryClient.setQueryData<Doc>([QueryKey.DOCS, updatedDoc._id], updatedDoc);

    //   queryClient.setQueryData<Doc[]>([QueryKey.DOCS], (contents) =>
    //     contents?.map((content) => (content._id === updatedDoc._id ? updatedDoc : content))
    //   );
    // },
  });

  return {
    isDocLoading,
    doc,
    refetch,
  };
};
